import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';

function Us({ configData, isLoading }) {
    const navigate = useNavigate();
    // Al entrar a la página, subimos el scroll arriba de todo y cambiamos el título
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "Quiénes Somos | Somnus";
        return () => { document.title = "Somnus"; };
    }, []);

    // Extraemos el dato correctamente sin importar si Django manda objeto o array
    const config = Array.isArray(configData) ? configData[0] : configData;

    const tieneContenido = (htmlText) => {
        return htmlText && htmlText.replace(/<[^>]+>/g, '').trim() !== '';
    };


    return (
        <main className="page-cursos font-n">
            <div className="banner-course">
                <h4>Quienes Somos</h4>
            </div>
            <section className="page-cursos-content">
                <div className="btn-back-container">
                    <button onClick={() => navigate(-1)}>
                        <i className="ri-arrow-go-back-line d-inline d-md-none"></i><span className="d-none d-md-inline">Volver</span>
                    </button>
                </div>

                <section className="section-us font-n">
                    <div className="div-img-us">
                        <img src="/img/carousel/grupo.webp" alt="Presentación grupo de trabajo" />
                    </div>
                    <div className="div-info-u">
                        <div className="txt-us">
                            {isLoading ? (
                                <p className="loading-txt">Cargando información institucional...</p>
                            ) : tieneContenido(config?.quienes_somos_resumen) ? (
                                <div
                                    className="valores-body-text"
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.quienes_somos_resumen) }}
                                />
                            ) : (
                                <p>
                                    Estamos puliendo los detalles de nuestra identidad corporativa. Muy pronto podrás conocer más sobre nosotros.
                                </p>
                            )}
                        </div>

                        <div className="div-vm">
                            <div className="card-mission">
                                <p>Misión</p>
                                <div className="content-card-us">
                                    {isLoading ? (
                                        <span>Cargando misión...</span>
                                    ) : tieneContenido(config?.mision) ? (
                                        <div
                                            className="valores-body-text"
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.mision) }}
                                        />
                                    ) : (
                                        <p>
                                            Estamos puliendo los detalles de nuestra identidad corporativa. Muy pronto podrás conocer más sobre nosotros.
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="card-vision">
                                <p>Visión</p>
                                <div className="content-card-us">
                                    {isLoading ? (
                                        <span>Cargando visión...</span>
                                    ) : tieneContenido(config?.vision) ? (
                                        <div
                                            className="valores-body-text"
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.vision) }}
                                        />
                                    ) : (
                                        <p>
                                            Estamos puliendo los detalles de nuestra identidad corporativa. Muy pronto podrás conocer más sobre nosotros.
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="card-valores">
                                <p>Valores</p>
                                <div className="content-card-us">
                                    {isLoading ? (
                                        <span>Cargando Valores...</span>
                                    ) : tieneContenido(config?.valor) ? (
                                        <div
                                            className="valores-body-text"
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.valor) }}
                                        />
                                    ) : (
                                        <p>
                                            Estamos puliendo los detalles de nuestra identidad corporativa. Muy pronto podrás conocer más sobre nosotros.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </main>
    );
}

export default Us;